/**
 * Unified Zoom Configuration
 * Centralized zoom constants — single source of truth.
 *
 * Originally in universal_architecture/config/ZoomConfig.ts,
 * moved here as part of /src/config/ centralization.
 */

/**
 * Unified Zoom Constants
 * Single source of truth for all zoom-related configurations
 */
export const UNIFIED_ZOOM_CONSTANTS = {
    // Core zoom limits
    MIN_ZOOM: 0.4,               // Minimum zoom level
    MAX_ZOOM: 10.0,              // Maximum zoom level
    DEFAULT_ZOOM: 1,             // Default zoom level
    STEP: 0.05,                  // Zoom step increment

    // Fixed mode settings
    FIXED_ZOOM_LEVEL: 1,         // Default zoom level for fixed mode

    // Fit mode settings
    FIT_PADDING: 0,              // Padding percentage for fit mode

    // Performance settings
    ZOOM_THROTTLE_MS: 100,       // Throttle zoom events (ms)
    ZOOM_DEBOUNCE_MS: 50,        // Debounce zoom changes (ms)

    // Transition settings
    ZOOM_TRANSITION_DURATION: 250, // Zoom animation duration (ms)

    // Display mode thresholds (consolidated from ZoomSystemTest)
    SYMBOLS_THRESHOLD: 0.5,      // Threshold for symbols mode
    FULL_THRESHOLD: 1.5          // Threshold for full mode
} as const;

/**
 * Zoom-based font size configuration
 * Controls font sizes for different zoom levels
 */
export const ZOOM_FONT_SIZE_CONFIG = {
    symbols: 42,    // Small zoom - small font for symbols
    short: 32,      // Medium zoom - medium font for short names
    full: 24        // Large zoom - large font for full names
} as const;
